import React from 'react';

const REASONS = [
    { n: '01', title: 'Amplify the readiness of every company you graduate', body: 'Your programme makes the business better. Diligentsia makes sure investors find the same quality behind the pitch as in it.' },
    { n: '02', title: 'See exactly where every cohort company stands, in real time', body: 'Completeness scores, risk flags, and certification, updated continuously — weeks before an investor conversation begins.' },
    { n: '03', title: 'Turn demo day conversations into commitments', body: "When interest moves past the pitch, what's behind it needs to match — governance, ownership, contracts, risk." },
    { n: '04', title: 'Free your mentors from formatting work', body: "Clarence auto-populates up to 60% of diligence modules from each company's own documents. Mentors focus on strategy, not structuring." },
    { n: '05', title: "Don't let your companies get exposed by someone else's AI", body: 'Investors already run AI diligence. Programmes whose graduates arrive certified have a measurable, compounding advantage.' },
    { n: '06', title: 'Screen investment readiness, not just the pitch', body: "AI can score a market opportunity. It can't tell you if the IP is in dispute or the cap table doesn't reconcile. We add that layer." },
    { n: '07', title: 'Give every applicant a constructive next step', body: "Companies you don't accept are introduced to Diligentsia's broader network — a warm handover, not a dead end." },
    { n: '08', title: 'Keep sight of your portfolio after the programme ends', body: "Diligentsia keeps every graduate's readiness record live and connected to InvestorMatch, long after demo day." },
    { n: '09', title: 'Produce the outcome data your sponsors are asking for', body: 'Completion rates, readiness scores, certification levels, and funded outcomes — always current, never chased.' },
];

const AccFirstMoversSection = () => (
    <section className="lp-acc-sec lp-acc-sec--black">
        <div className="lp-acc-wrap">
            <span className="lp-acc-kicker" data-lp-reveal>Why programme directors are moving now</span>
            <h2 className="lp-acc-h2" data-lp-reveal data-lp-delay="60">First movers set the standard. Everyone else adopts it later, from a weaker position.</h2>

            <div className="lp-acc-reasons">
                {REASONS.map((r, i) => (
                    <div className="lp-acc-reason" key={r.n} data-lp-reveal data-lp-delay={(i % 3) * 80}>
                        <div className="rn">{r.n}</div>
                        <h4>{r.title}</h4>
                        <p>{r.body}</p>
                    </div>
                ))}
            </div>

            <div className="lp-acc-pullquote" data-lp-reveal>
                "It's not that it doesn't get done. It just takes longer to answer those questions three weeks down the line than if they're answered three days into it."
                <cite>— Investment Manager, EHE Ventures</cite>
            </div>
        </div>
    </section>
);

export default AccFirstMoversSection;
